import { render, staticRenderFns } from "./WorkspaceListTable.vue?vue&type=template&id=62fca901&"
import script from "./WorkspaceListTable.vue?vue&type=script&lang=js&"
export * from "./WorkspaceListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports